import { Instagram, Facebook, Linkedin } from "lucide-react";
import useSiteSettings from "../lib/useSiteSettings";
const PROFILES = [
  ["Instagram", "instagram", Instagram],
  ["Facebook", "facebook", Facebook],
  ["LinkedIn", "linkedin", Linkedin],
];
export default function SocialLinks({ dark = false, labels = false, className = "" }) {
  const settings = useSiteSettings();
  return <div className={"flex flex-wrap items-center gap-2 " + className} aria-label="Official social profiles">
    {PROFILES.filter(([, key]) => /^https:\/\//.test(settings[key] || "")).map(([label, key, Icon]) => <a key={label} href={settings[key]} target="_blank" rel="noopener noreferrer" aria-label={"S H & SONS ® on " + label}
      className={"inline-flex min-h-11 min-w-11 items-center justify-center gap-2 rounded-full px-3 transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 " + (dark ? "text-white/70 hover:text-white hover:bg-white/10" : "text-mocha hover:text-ink hover:bg-cream")}>
      <Icon className="h-[18px] w-[18px] shrink-0" strokeWidth={1.6} aria-hidden="true" />
      {labels && <span className="text-xs">{label}</span>}
    </a>)}
  </div>;
}
